import { IAdvertisementBase } from '../../models/advertisements';
import { IUserBase } from '../../models/users';
import cjPontanegraApi from '../apis/cjPontanegraApi';

interface IUpdateUserProps {
  userId: string;
  birthDate: Date;
  cpf: string;
  email: string;
  gender: 'FEMALE' | 'MALE' | 'OTHER' | 'UNDEFINED';
  name: string;
  phone?: string;
}

export interface IUpdatedUser extends IUserBase {
  favorites: IAdvertisementBase[];
}

export const updateCustomersService = async ({
  userId,
  birthDate,
  cpf,
  email,
  gender,
  name,
  phone,
}: IUpdateUserProps): Promise<IUpdatedUser> => {
  const { data } = await cjPontanegraApi.put<IUpdatedUser>(
    `/customers/${userId}`,
    {
      birthDate,
      cpf,
      email,
      gender,
      name,
      phone,
    },
  );

  return data;
};
